import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/tags`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/tags/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/tags/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/tags`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/tags/${itemId}`);
  },
};
